import { BASE_URL } from "../constants/defaultValues";
import axios from "axios";
import { configureStore } from "../redux/store";

export const platform = "web";

export async function apiCall(
  isAuthorized = false,
  type = "GET",
  appendUrl,
  data = {},
  isJson = true,
  isAccount = true,
  isFormEncoded = false,
  accountIDD = false
) {
  let reqHeaders = {};
  // let strigifiedData = data
  // if( stringify ){
  // }
  // const store = configureStore();
  // let state = store.getState();

  if (isAuthorized) {
    let token = localStorage.getItem("user_id");
    reqHeaders.Authorization = "bearer " + token;
  }
  if (isAccount) {
    let accountId = localStorage.getItem("activeAccount");
    reqHeaders.account = accountId;
  }
  if (accountIDD) {
    reqHeaders.account = accountIDD;
  }

  if ((type === "POST" || type === "PUT") && isJson) {
    reqHeaders["Content-Type"] = "application/json";
    data = JSON.stringify(data);
    if (!isAuthorized) {
      // reqHeaders.'Access-Control-Allow-Origin' =  '*',
      reqHeaders.Accept = "application/json";
    }
  }

  if (isFormEncoded) {
    reqHeaders["Content-Type"] = "application/x-www-form-urlencoded";
  }

  try {
    switch (type) {
      case "GET":
        return await axios.get(BASE_URL + appendUrl, { headers: reqHeaders });
        break;
      case "DELETE":
        return await axios.delete(
          BASE_URL + appendUrl,
          { headers: reqHeaders },
          data
        );
        break;
      case "POST":
        return await axios.post(BASE_URL + appendUrl, data, {
          headers: reqHeaders,
        });
        break;
      case "PUT":
        return await axios.put(BASE_URL + appendUrl, data, {
          headers: reqHeaders,
        });
        break;
      default:
        console.log("apiCallError this type not handled here", type);
    }
  } catch (error) {
    if (error?.response?.status == 401) {
      removeFromStorage("user_id");
      removeFromStorage("user");
      removeFromStorage("login");
      window.location.reload();
    }
    return false;
  }
}

export const restrictedURLsForBasic = [
  "audit-logs",
  "upcoming-reminders",
  "reminders",
  "employee-management",
];

export function isAdminUser() {
  let user = localStorage.getItem("user");
  let result = false;
  if (user.length) {
    user = JSON.parse(user);
  } else {
    user = false;
  }

  if (user && (user.role == 3 || user.role == 5)) {
    result = true;
  }

  return result;
}

export function isRestrictedItem(item) {
  let user = localStorage.getItem("user");
  if (user.length) {
    user = JSON.parse(user);
  } else {
    user = false;
  }

  if (!isAdminUser() && item.id == "settings") {
    return false;
  } else if (
    user &&
    user.account.stripe_price_id == 0 &&
    (restrictedURLsForBasic.indexOf(item.to) !== -1 ||
      restrictedURLsForBasic.includes(item.to.replace("/app/", "")))
  ) {
    return false;
  }
  return true;
}

export function getFromStorage(key) {
  return localStorage.getItem(key);
}
export function setToStorage(key, value) {
  return localStorage.setItem(key, value);
}
export function removeFromStorage(key) {
  return localStorage.removeItem(key);
}
